export const HIGH_AVAILABILITY = {
    YES: 'Yes',
    NO: 'No',
};

export const COMMON = {
    YES: 'Yes',
    NO: 'No',
    PRODUCTION: 'Production',
};

export const DATABASE_NAME_VALIDATION_MSG =
    'Database name must start with an uppercase letter, contain only uppercase letters and numbers, and be 1–14 characters long.';
export const STARTS_WITH_NUMBER_MSG = 'Database name should not start with a number.';
export const RESOURCE_GROUP_MSG = "Resource Group Name must end with 'rg' within 3 to 33 chars.";
export default {};
